{
    "statusType": {
        "DEACTIVE": "Not activated",
        "NOT_REGISTER": "Standby",
        "REGISTER": "Active",
        "EXPIRED": "Expired",
        "RETURNED": "Returned"
    }
}
